import React from "react";
import { Navigate } from "react-router-dom";
import { urlEndPoint } from "helpers/GeneralHelper";

import Login from "../pages/Authentication/Login";
import SsoCallback from "../pages/Authentication/SsoCallback";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import UserProfile from "../pages/Authentication/user-profile";

import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import CurrentApiStatus from "components/Common/CurrentApiStatus";

import RoleBasedDashboard from "../pages/Dashboard/RoleBasedDashboard";
import BackendDashboard from "pages/Dashboard/BackendDashboard";
import RecruiterDashboard from "pages/Dashboard/RecruiterDashboard";
import AccountExecutiveWeeklyDashboard from "pages/Dashboard/AccountExecutiveWeeklyDashboard";

import JobCategory from "pages/Master/JobCategory/job-category";
import JobRequired from "pages/Master/JobRequired/job-required";
import AIScheduleMatrixGroup from "pages/Master/AIScheduleMatrixGroup/ai-schedule-matrix-group";
import TaskGroupSettings from "pages/Master/TaskGroupSettings/task-group-settings";
import QuestionType from "pages/Master/QuestionType/question-type";
import RegisterField from "pages/Master/RegisterField/register-field";
import Job from "pages/Master/Job/job";
import BadFitResolutionReason from "pages/Master/BadFitResolutionReason/bad-fit-resolution-reason";
import Source from "pages/Master/Source/source";
import DocRequired from "pages/Master/DocRequired/doc-required";
import OnboardingDocuments from "pages/Master/OnboardingDocuments/onboarding-documents";
import TaskBucket from "pages/Master/TaskBucket/task-bucket";
import Reason from "pages/Master/Reason/reason";
import AuditingTemplates from "pages/Master/AuditingTemplates/auditing-templates";
import AuditingParameter from "pages/Master/AuditingParameter/auditing-parameter";
import Legends from "pages/Master/Legends/legends";
import TwilioPhoneNumber from "pages/Master/TwilioPhoneNumber/twilio-phone-number";

import Company from "pages/Client/Company/company";
import FindCompanyUser from "pages/Client/FindCompanyUser/find-company-user";
import Client from "pages/Client/ClientSection/client";
import SourceSection from "pages/Client/Source/source";
import ClientReview from "pages/Client/ClientReview/client-review";
import ClientReviewEdit from "pages/Client/ClientReview/client-review-edit";
import PreQuestioning from "pages/Client/PreQuestioning/pre-questioning";
import JobDescription from "pages/Client/JobDescription/job-description";
import ClientAppreciation from "pages/Client/ClientAppretiation/client-appretiation";
import OnboardingList from "pages/Client/OnBoardingList/onboarding-list";
import AddEditOnboarding from "pages/Client/OnBoardingList/add-edit-onboarding";
import OffboardingList from "pages/Client/OffBoardingList/offboarding-list";
import ClientRegister from "pages/Client/ClientRegister/client-register";
import ClientRegisterAddEditModal from "pages/AllCommonModal/ClientRegisterAddEditModal.jsx/client-register-add-edit-modal";
import JobDescriptionAddEditModal from "pages/AllCommonModal/JobDescriptionAddEditModal/job-description-add-edit-modal";
import ClientDetails from "pages/ClientDetails/client-details";

import NewCandidate from "pages/Candidates/NewCandidate/new-candidate";
import AllCandidates from "pages/Candidates/AllCandidates/all-candidates";
import CandidateHireStatus from "pages/Candidates/CandidateHireStatus/candidate-hire-status";
import ExternalLeads from "pages/Candidates/ExternalLeads/external-leads";
import CandidateOnboarding from "pages/Candidates/CandidateOnboarding/candidate-onboarding";
import UploadDrugCSV from "pages/Candidates/UploadDrugCSV/upload-drug-csv";
import UploadBulkCV from "pages/Candidates/UploadBulkCV/upload-bulk-CV";
import UploadProfileCSV from "pages/Candidates/UploadProfileCSV/upload-profile-csv";
import CallBackRequest from "pages/Candidates/CallBackRequest/call-back-request";
import FadvCsvLog from "pages/Candidates/FadvCsvLog/fadv-csv-log";
import FadvOrderLog from "pages/Candidates/FadvOrderLog/fadv-order-log";
import FadvProfileOrderLog from "pages/Candidates/FadvProfileOrderLog/fadv-profile-order-log";
import VerifyFadvCsv from "pages/Candidates/VerifyFadvCsv/verify-fadv-csv";
import BlockFadvRequestor from "pages/Candidates/BlockFadvRequestor/block-fadv-requestor";
import VerifyTest from "pages/Candidates/VerifyTest/verify-test";
import ModifyClosure from "pages/Candidates/ModifyClosure/modify-closure";
import BadFit from "pages/Candidates/BadFit/bad-fit";

import Schedule from "pages/Call/Executive/schedule";
import Today from "pages/Call/Executive/today";
import WrongNumber from "pages/Call/Executive/wrong-number";
import UnderAge from "pages/Call/Executive/under_age";
import ExecutiveOrderInProgress from "pages/Call/Executive/order-in-progress";
import InProgress from "pages/Call/Manager/in-progress";
import ReadyToSendUpdate from "pages/Call/Manager/ready-to-send-update-send";
import FurtherReview from "pages/Call/Manager/further-review";
import FedexDriver from "pages/Call/Manager/fedex-driver";
import MyCall from "pages/Call/my-call";
import DeactivateCandidate from "pages/Call/deactivate-candidate";
import CallDetails from "pages/CallDetails/call-details";

import InProgressReport from "pages/ReportSection/InprogressReport/inprogress-report";
import ClientReport from "pages/ReportSection/ClientReport/client-report";
import EligibleReport from "pages/ReportSection/EligibleReport/eligible-report";
import ClosureReport from "pages/ReportSection/ClosureReport/closure-report";
import ClientUserReport from "pages/ReportSection/ClientUserReport/client-user-report";
import CandidateSummaryReport from "pages/ReportSection/CandidateSummaryReport/candidate-summary-report";
import LeadsAddedReport from "pages/ReportSection/LeadsAddedReport/leads-added-report";
import ClientStatusReport from "pages/ReportSection/ClientStatusReport/client-status-report";
import TeamPerformanceReport from "pages/ReportSection/TeamPerformanceReport/team-performance-report";
import BackendPerformanceReport from "pages/ReportSection/BackendPerformanceReport/backend-performance-report";
import MonthWiseSummaryReport from "pages/ReportSection/MonthWiseSummaryReport/month-wise-summary-report";
import ComplianceReport from "pages/ReportSection/ComplianceReport/compliance-report";
import NotInterestedReport from "pages/ReportSection/NotInterestedReport/not-interested-report";
import SegmentCompletion from "pages/ReportSection/SegmentCompletion/segment-completion";
import CallerPerformanceReport from "pages/ReportSection/CallerPerformanceReport/caller-performance-report";
import ReadyToSendReport from "pages/ReportSection/ReadyToSend/ready-to-send-report";
import DrugCsvUploadReport from "pages/ReportSection/DrugCsvUploadReport/drug-csv-upload-report";
import SessionReport from "pages/ReportSection/SessionReport/session-report";
import UserClientActivityReport from "pages/ReportSection/UserClientActivityReport/user-client-activity-report";
import RtrInternalReport from "pages/ReportSection/RtrInternalReport/rtr-internal-report";
import SmePerformanceReport from "pages/ReportSection/SmePerformanceReport/sme-performance-report";

import Achievements from "pages/Incentive/Achievements/achievements";
import MonthyList from "pages/Incentive/MonthyList/monthy-list";
import MonthlyDetails from "pages/Incentive/MonthyList/monthy-details";
import AchievementsTwo from "pages/Incentive/Achievements/achievements-two";
import MonthlyListTwo from "pages/Incentive/MonthyList/monthly-list-two";
import MonthlyDetailsTwo from "pages/Incentive/MonthyList/monthly-details-two";

import AchievementsThree from "pages/Incentive/Achievements/acheivements-three";
import MonthlyListThree from "pages/Incentive/MonthyList/monthly-list-three";
import MonthlyDetailsThree from "pages/Incentive/MonthyList/monthly-details-three";

import TeamRecognitionAchievements from "pages/TeamRecognition/Achievements/achievements";
import TeamRecognitionMonthyList from "pages/TeamRecognition/MonthyList/monthy-list";
import TeamRecognitionMonthlyDetails from "pages/TeamRecognition/MonthyList/monthy-details";

import CallAudit from "pages/Audit/CallAudit/call-audit";
import EditViewCallEdit from "pages/Audit/CallAudit/edit-view-call-edit";

import MailTemplate from "pages/Settings/MailTemplate/mail-template";
import AddEditMailTemplate from "pages/Settings/MailTemplate/add-edit-mail-template";
import NotificationSettings from "pages/Settings/NotificationSettings/notification-settings";
import BroadcastNotification from "pages/Settings/BroadcastNotification/broadcast-notification";
import UserIpSettings from "pages/Settings/UserIPSettings/user-ip-settings";
import TestEmailServer from "pages/Settings/TestEmailServer/test-email-server";

import Team from "pages/UserAndTeam/Team/team";
import Workshift from "pages/UserAndTeam/WorkShift/workshift";
import WorkingLetter from "pages/UserAndTeam/WarningLetter/warning-letter";
import UserType from "pages/UserAndTeam/UserType/user-type";
import UserTypeAddEdit from "pages/UserAndTeam/UserType/user-type-add-edit";
import ManageUserAddEdit from "pages/UserAndTeam/ManageUser/manage-user-add-edit";
import ManageUser from "pages/UserAndTeam/ManageUser/manage-user";
import CompanyUser from "pages/UserAndTeam/CompanyUser/company-user";
import CompanyUserAddEdit from "pages/UserAndTeam/CompanyUser/company-user-add-edit";
import AttendanceReport from "pages/UserAndTeam/AttendanceReport/attendance-report";
import UserActivities from "pages/UserAndTeam/UserActivities/user-activities";

import AiRecruiterLog from "pages/AIRecruiter/ai-recruiter-log";
import CallScheduledReport from "pages/AIRecruiter/call-scheduled-report";
import AllNotifications from "pages/AllNotifications/all-notifications";
import SimpleAllNotifications from "pages/AllNotifications/simple-all-notification";
import TaskPlanner from "pages/TaskPlanner/task-planner";
import AccessDenied from "components/Common/AccessDenied";
import NoPermission from "pages/NoPermission";
import ClientJourney from "pages/TaskPlanner/client-journey";
import RtrAcknowledge from "pages/Call/Executive/rtr-acknowledge";
import AIDashboard from "pages/Dashboard/AIDashboard";
import AiFadvReport from "pages/ReportSection/AIFadvReport/ai-fadv-report";
import AddEditConversationTemplate from "pages/Settings/ConversationSettings/add-edit-conversation-template";
import ConversationTemplate from "pages/Settings/ConversationSettings/conversation-template";
import ConversationMatrix from "pages/Settings/ConversationSettings/conversation-matrix";
import AiFadvPackage from "pages/Master/AIFadvPackage/ai-fadv-package";
import ClientPlan from "pages/Master/ClientPlan/client-plan";
import AiSmsTemplate from "pages/Settings/AISmsSettings/ai-sms-template";
import AddEditAISmsTemplate from "pages/Settings/AISmsSettings/add-edit-ai-sms-template";
import AiScheduleMatrix from "pages/Call/ai-schedule-matrix";
import NotOnAi from "pages/Call/Executive/not-on-ai";
import AiAddonCallTemplate from "pages/Settings/AIAddOnCallSettings/ai-addon-call-template";
import AddEditAIAddonTemplate from "pages/Settings/AIAddOnCallSettings/add-edit-ai-addon-call-template";
import VerifyApplicationFile from "pages/Candidates/VerifyApplicationFile/verify-application-file";
import InternalTaskPlanner from "pages/TaskPlanner/internal-task-planner";
import AiRecruiterClient from "pages/AIRecruiter/ai-recruiter-client";

const authProtectedRoutes = [
  { path: "/dashboard", component: <RoleBasedDashboard /> },
  { path: "/profile", component: <UserProfile /> },

  { path: `${urlEndPoint.backendDashboard}`, component: <BackendDashboard /> },
  { path: `${urlEndPoint.recruiterDashboard}`, component: <RecruiterDashboard /> },
  { path: `${urlEndPoint.accountExecutiveDashboard}`, component: <AccountExecutiveWeeklyDashboard /> },
  { path: `${urlEndPoint.AIDashboard}`, component: <AIDashboard /> },


  { path: `${urlEndPoint.taskPlanner}/:taskId`, component: <TaskPlanner /> },
  { path: `${urlEndPoint.taskPlanner}`, component: <TaskPlanner /> },
  { path: `${urlEndPoint.clientJourney}/:taskId`, component: <ClientJourney /> },
  { path: `${urlEndPoint.clientJourney}`, component: <ClientJourney /> },

  { path: `${urlEndPoint.internalTaskPlanner}/:taskId`, component: <InternalTaskPlanner /> },
  { path: `${urlEndPoint.internalTaskPlanner}`, component: <InternalTaskPlanner /> },

  { path: `${urlEndPoint.jobCategoryUrl}`, component: <JobCategory /> },
  { path: `${urlEndPoint.aiFadvPackageUrl}`, component: <AiFadvPackage /> },
  { path: `${urlEndPoint.clientPlan}`, component: <ClientPlan /> },
  { path: `${urlEndPoint.jobRequiredUrl}`, component: <JobRequired /> },
  { path: `${urlEndPoint.taskGroupSettingsUrl}`, component: <TaskGroupSettings /> },
  { path: `${urlEndPoint.aiScheduleMatrixGroupUrl}`, component: <AIScheduleMatrixGroup /> },
  { path: `${urlEndPoint.questionTypeUrl}`, component: <QuestionType /> },
  { path: `${urlEndPoint.registerFieldUrl}`, component: <RegisterField /> },
  { path: `${urlEndPoint.jobUrl}`, component: <Job /> },
  { path: `${urlEndPoint.badFitResolutionReasonUrl}`, component: <BadFitResolutionReason /> },
  { path: `${urlEndPoint.sourceUrl}`, component: <Source /> },
  { path: `${urlEndPoint.reasonUrl}`, component: <Reason /> },
  { path: `${urlEndPoint.docRequiredUrl}`, component: <DocRequired /> },
  { path: `${urlEndPoint.onboardingDocumentsUrl}`, component: <OnboardingDocuments /> },
  { path: `${urlEndPoint.onboardingDocUrl}`, component: <OnboardingDocuments /> },
  { path: `${urlEndPoint.taskBucketUrl}`, component: <TaskBucket /> },
  { path: `${urlEndPoint.legends}`, component: <Legends /> },
  { path: `${urlEndPoint.auditingParameter}`, component: <AuditingParameter /> },
  { path: `${urlEndPoint.auditingTemplates}`, component: <AuditingTemplates /> },
  { path: `${urlEndPoint.twilioPhone}`, component: <TwilioPhoneNumber /> },

  { path: `${urlEndPoint.company}`, component: <Company /> },
  { path: `${urlEndPoint.findCompanyUser}`, component: <FindCompanyUser /> },
  { path: `${urlEndPoint.clientUser}`, component: <Client /> },
  { path: `${urlEndPoint.source}`, component: <SourceSection /> },
  { path: `${urlEndPoint.clientReview}`, component: <ClientReview /> },
  { path: `${urlEndPoint.clientReviewAdd}`, component: <ClientReviewEdit /> },
  { path: `${urlEndPoint.clientReviewEdit}`, component: <ClientReviewEdit /> },
  { path: `${urlEndPoint.clientReviewEdit}/:clientId`, component: <ClientReviewEdit /> },
  { path: `${urlEndPoint.notificationClientReviewEdit}/:clientId`, component: <ClientReviewEdit /> },
  { path: `${urlEndPoint.notificationClientReviewEdit}`, component: <ClientReviewEdit /> },
  { path: `${urlEndPoint.preQuestioning}`, component: <PreQuestioning /> },
  { path: `${urlEndPoint.preQuestioning}/:clientId`, component: <PreQuestioning /> },
  { path: `${urlEndPoint.jobDescription}`, component: <JobDescription /> },
  { path: `${urlEndPoint.jobDescriptionAddEdit}/:clientId/:jobDescriptionId`, component: <JobDescriptionAddEditModal /> },
  { path: `${urlEndPoint.clientAppreciation}`, component: <ClientAppreciation /> },
  { path: `${urlEndPoint.clientAppreciations}/:clientId`, component: <ClientAppreciation /> },
  { path: `${urlEndPoint.onboardingList}`, component: <OnboardingList /> },
  { path: `${urlEndPoint.addEditOnboarding}`, component: <AddEditOnboarding /> },
  { path: `${urlEndPoint.offBoardingList}`, component: <OffboardingList /> },
  { path: `${urlEndPoint.clientRegister}`, component: <ClientRegister /> },
  { path: `${urlEndPoint.clientRegisterAddEdit}`, component: <ClientRegisterAddEditModal /> },
  { path: `${urlEndPoint.ClientJobDescription}/:clientId`, component: <JobDescription /> },
  { path: `${urlEndPoint.clientDetaisUrl}`, component: <ClientDetails /> },

  { path: `${urlEndPoint.newCandidateAdd}`, component: <NewCandidate /> },
  { path: `${urlEndPoint.allCandidates}`, component: <AllCandidates /> },
  { path: `${urlEndPoint.candidateHireStatus}`, component: <CandidateHireStatus /> },
  { path: `${urlEndPoint.externalLeads}`, component: <ExternalLeads /> },
  { path: `${urlEndPoint.candidateOnboarding}`, component: <CandidateOnboarding /> },
  { path: `${urlEndPoint.uploadDrugCSV}`, component: <UploadDrugCSV /> },
  { path: `${urlEndPoint.uploadBulkCV}`, component: <UploadBulkCV /> },
  { path: `${urlEndPoint.uploadProfileCSV}`, component: <UploadProfileCSV /> },
  { path: `${urlEndPoint.candidateCallBackRequest}`, component: <CallBackRequest /> },
  { path: `${urlEndPoint.fadvCsvLog}`, component: <FadvCsvLog /> },
  { path: `${urlEndPoint.fadvOrderLog}`, component: <FadvOrderLog /> },
  { path: `${urlEndPoint.fadvProfileOrderLog}`, component: <FadvProfileOrderLog /> },
  { path: `${urlEndPoint.verifyFadvCsv}`, component: <VerifyFadvCsv /> },
  { path: `${urlEndPoint.verifyApplicationFile}`, component: <VerifyApplicationFile /> },
  { path: `${urlEndPoint.blockFadvRequestor}`, component: <BlockFadvRequestor /> },
  { path: `${urlEndPoint.verifyTest}`, component: <VerifyTest /> },
  { path: `${urlEndPoint.modifyClosure}`, component: <ModifyClosure /> },
  { path: `${urlEndPoint.badFit}`, component: <BadFit /> },

  { path: `${urlEndPoint.schedule}`, component: <Schedule /> },
  { path: `${urlEndPoint.aiScheduleMatrix}`, component: <AiScheduleMatrix /> },
  { path: `${urlEndPoint.rtrAcknowledgement}`, component: <RtrAcknowledge /> },
  { path: `${urlEndPoint.today}`, component: <Today /> },
  { path: `${urlEndPoint.recruiterToday}`, component: <Today /> },
  { path: `${urlEndPoint.wrongNumber}`, component: <WrongNumber /> },
  { path: `${urlEndPoint.underAge}`, component: <UnderAge /> },
  { path: `${urlEndPoint.executiveOrderInProgress}`, component: <ExecutiveOrderInProgress /> },
  { path: `${urlEndPoint.inProgress}`, component: <InProgress /> },
  { path: `${urlEndPoint.readyToSendUpdate}`, component: <ReadyToSendUpdate /> },
  { path: `${urlEndPoint.furtherReview}`, component: <FurtherReview /> },
  { path: `${urlEndPoint.fedexDriverReview}`, component: <FedexDriver /> },
  { path: `${urlEndPoint.myCall}`, component: <MyCall /> },
  { path: `${urlEndPoint.deactivateCandidate}`, component: <DeactivateCandidate /> },
  { path: `${urlEndPoint.callDetailsUrl}/:id`, component: <CallDetails /> },
  { path: `${urlEndPoint.notificationCallDetailsUrl}/:id`, component: <CallDetails /> },
  { path: `${urlEndPoint.notificationCallDetailsUrl}/:id/:openDriverDetails`, component: <CallDetails /> },

  { path: `${urlEndPoint.inprogressReport}`, component: <InProgressReport /> },
  { path: `${urlEndPoint.inProgressReport}`, component: <InProgressReport /> },
  { path: `${urlEndPoint.clientReport}`, component: <ClientReport /> },
  { path: `${urlEndPoint.eligibleReport}`, component: <EligibleReport /> },
  { path: `${urlEndPoint.closureReport}`, component: <ClosureReport /> },
  { path: `${urlEndPoint.clientUserReport}`, component: <ClientUserReport /> },
  { path: `${urlEndPoint.clientSummaryReport}`, component: <CandidateSummaryReport /> },
  { path: `${urlEndPoint.leadsAddedReport}`, component: <LeadsAddedReport /> },
  { path: `${urlEndPoint.clientStatusReport}`, component: <ClientStatusReport /> },
  { path: `${urlEndPoint.teamPerformanceReport}`, component: <TeamPerformanceReport /> },
  { path: `${urlEndPoint.backendPerformanceReport}`, component: <BackendPerformanceReport /> },
  { path: `${urlEndPoint.monthWiseSummaryReport}`, component: <MonthWiseSummaryReport /> },
  { path: `${urlEndPoint.compliancyReport}`, component: <ComplianceReport /> },
  { path: `${urlEndPoint.notInterestedAnymore}`, component: <NotInterestedReport /> },
  { path: `${urlEndPoint.notInterestedReport}`, component: <NotInterestedReport /> },
  { path: `${urlEndPoint.segmentCompletionReport}`, component: <SegmentCompletion /> },
  { path: `${urlEndPoint.callerPerformanceReport}`, component: <CallerPerformanceReport /> },
  { path: `${urlEndPoint.readyToSendReport}`, component: <ReadyToSendReport /> },
  { path: `${urlEndPoint.drugCsvUploadReport}`, component: <DrugCsvUploadReport /> },
  { path: `${urlEndPoint.sessionActivityReport}`, component: <SessionReport /> },
  { path: `${urlEndPoint.userClientActivityReport}`, component: <UserClientActivityReport /> },
  { path: `${urlEndPoint.rtrInternalReport}`, component: <RtrInternalReport /> },
  { path: `${urlEndPoint.smePerformanceReport}`, component: <SmePerformanceReport /> },

  { path: `${urlEndPoint.achievements}`, component: <Achievements /> },
  { path: `${urlEndPoint.monthlyList}`, component: <MonthyList /> },
  { path: `${urlEndPoint.monthlyDetails}/:id`, component: <MonthlyDetails /> },
  { path: `${urlEndPoint.achievementsTwo}`, component: <AchievementsTwo /> },
  { path: `${urlEndPoint.monthlyListTwo}`, component: <MonthlyListTwo /> },
  { path: `${urlEndPoint.monthlyDetailsTwo}/:id`, component: <MonthlyDetailsTwo /> },
  { path: `${urlEndPoint.achievementsThree}`, component: <AchievementsThree /> },
  { path: `${urlEndPoint.monthlyListThree}`, component: <MonthlyListThree /> },
  { path: `${urlEndPoint.monthlyDetailsThree}/:id`, component: <MonthlyDetailsThree /> },

  { path: `${urlEndPoint.teamRecognitionAchievements}`, component: <TeamRecognitionAchievements /> },
  { path: `${urlEndPoint.teamRecognitionMonthlyList}`, component: <TeamRecognitionMonthyList /> },
  { path: `${urlEndPoint.teamRecognitionMonthlyDetails}/:id`, component: <TeamRecognitionMonthlyDetails /> },

  { path: `${urlEndPoint.callAudit}`, component: <CallAudit /> },
  { path: `${urlEndPoint.editcallAudit}/:auditId`, component: <EditViewCallEdit /> },
  { path: `${urlEndPoint.viewcallAudit}/:auditId`, component: <EditViewCallEdit /> },

  { path: `${urlEndPoint.mailTemplate}`, component: <MailTemplate /> },
  { path: `${urlEndPoint.addEditMail}/:id`, component: <AddEditMailTemplate /> },
  { path: `${urlEndPoint.addEditMail}`, component: <AddEditMailTemplate /> },

  { path: `${urlEndPoint.conversationTemplate}`, component: <ConversationTemplate /> },
  { path: `${urlEndPoint.conversationMatrix}`, component: <ConversationMatrix /> },
  { path: `${urlEndPoint.addEditConversation}/:id`, component: <AddEditConversationTemplate /> },
  { path: `${urlEndPoint.addEditConversation}`, component: <AddEditConversationTemplate /> },

  { path: `${urlEndPoint.notificationSetting}`, component: <NotificationSettings /> },
  { path: `${urlEndPoint.AISmsSetting}`, component: <AiSmsTemplate /> },
  { path: `${urlEndPoint.addEditAISms}/:id`, component: <AddEditAISmsTemplate /> },
  { path: `${urlEndPoint.addEditAISms}`, component: <AddEditAISmsTemplate /> },

  { path: `${urlEndPoint.AIAddonCallTemplateSetting}`, component: <AiAddonCallTemplate /> },
  { path: `${urlEndPoint.addEditAIAddonCallTemplate}/:id`, component: <AddEditAIAddonTemplate /> },
  { path: `${urlEndPoint.addEditAIAddonCallTemplate}`, component: <AddEditAIAddonTemplate /> },

  { path: `${urlEndPoint.broadcastNotification}`, component: <BroadcastNotification /> },
  { path: `${urlEndPoint.userIpSettings}`, component: <UserIpSettings /> },
  { path: `${urlEndPoint.testEmailServer}`, component: <TestEmailServer /> },

  { path: `${urlEndPoint.team}`, component: <Team /> },
  { path: `${urlEndPoint.workShift}`, component: <Workshift /> },
  { path: `${urlEndPoint.workLetter}`, component: <WorkingLetter /> },
  { path: `${urlEndPoint.userType}`, component: <UserType /> },
  { path: `${urlEndPoint.userTypeAddEdit}/:userTypeId`, component: <UserTypeAddEdit /> },
  { path: `${urlEndPoint.userTypeAddEdit}`, component: <UserTypeAddEdit /> },
  { path: `${urlEndPoint.manageUserAddEdit}/:userId`, component: <ManageUserAddEdit /> },
  { path: `${urlEndPoint.manageUserAddEdit}`, component: <ManageUserAddEdit /> },
  { path: `${urlEndPoint.manageUser}`, component: <ManageUser /> },
  { path: `${urlEndPoint.notificationManageUser}`, component: <ManageUser /> },
  { path: `${urlEndPoint.companyUser}/:companyId`, component: <CompanyUser /> },
  { path: `${urlEndPoint.companyUserAddEdit}/:companyId/:userId`, component: <CompanyUserAddEdit /> },
  { path: `${urlEndPoint.companyUserAddEdit}/:companyId`, component: <CompanyUserAddEdit /> },
  { path: `${urlEndPoint.attendanceReport}`, component: <AttendanceReport /> },
  { path: `${urlEndPoint.userActivities}`, component: <UserActivities /> },

  { path: `${urlEndPoint.aiRecruiterLog}`, component: <AiRecruiterLog /> },
  { path: `${urlEndPoint.callScheduledReport}`, component: <CallScheduledReport /> },
  { path: `${urlEndPoint.allNotifications}`, component: <AllNotifications /> },
  { path: `${urlEndPoint.simpleAllNotifications}`, component: <SimpleAllNotifications /> },
  { path: `${urlEndPoint.AIFadvReport}`, component: <AiFadvReport /> },

  { path: `${urlEndPoint.accessDenied}`, component: <AccessDenied /> },
  { path: "/no-permission", component: <NoPermission /> },
  { path: `${urlEndPoint.notOnAI}`, component: <NotOnAi /> },

  { path: `${urlEndPoint.AIRecruiterClient}`, component: <AiRecruiterClient /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/sso/callback", component: <SsoCallback /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: `${urlEndPoint.homeHealthStatus}`, component: <CurrentApiStatus /> },
];

export { authProtectedRoutes, publicRoutes };
